import Ripple from '../ripple'
const CLASS_RADIO_PRE = 'radio-group'
const CLASS_CHECKBOX_PRE = 'checkbox-group'

const Form = (function () {
    class FormMain {
        constructor(container, type) {
            this.$formGroup = container
            this.$input = null
            this.$circle = null
            this.$label = null
            this.type = type
        }

        init() {
            this._createCircle()
            this.addListener()
        }

        _createCircle() {
            if (this.$circle) this.$circle.remove()

            this.$circle = document.createElement('span')
            if (this.type === 'radio') {
                this.$circle.classList.add(`${CLASS_RADIO_PRE}__circle`)
            } else if (this.type === 'checkbox') {
                this.$circle.classList.add(`${CLASS_CHECKBOX_PRE}__circle`)
            }

            this.$circle.setAttribute('data-ripple', '')
            this.$circle.setAttribute('data-ripple-center', 'true')

            new Ripple(this.$circle)

            this.$label.prepend(this.$circle)
        }

        // Callbacks
        onChange() {
            if (this.$circle) this.$circle.getRipple().drawRipple()
        }

        addListener() {
            this.$input.addEventListener('change', () => this.onChange())
        }

    }


    class RadioGrp extends FormMain {
        constructor(container) {
            super(container, 'radio')
            this.$input = this.$formGroup.querySelector(`.${CLASS_RADIO_PRE}__input`)
            this.$circle = this.$formGroup.querySelector(`.${CLASS_RADIO_PRE}__circle`)
            this.$label = this.$formGroup.querySelector(`.${CLASS_RADIO_PRE}__label`)

            this.init()
        }
    }

    class CheckboxGrp extends FormMain {
        constructor(container) {
            super(container, 'checkbox')
            this.$input = this.$formGroup.querySelector(`.${CLASS_CHECKBOX_PRE}__input`)
            this.$circle = this.$formGroup.querySelector(`.${CLASS_CHECKBOX_PRE}__circle`)
            this.$label = this.$formGroup.querySelector(`.${CLASS_CHECKBOX_PRE}__label`)

            this.init()
        }
    }

    return {
        RadioGrp,
        CheckboxGrp
    }
})()

export default Form